import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ["redirectTo"]

    connect() {
        this.populateRedirectUrl()
    }

    populateRedirectUrl() {
        const redirectUrl = sessionStorage.getItem('loginRedirectUrl')
        if (redirectUrl) {
            this.redirectToTarget.value = redirectUrl
        }
    }
}
